import useLanguage from '@/utils/hooks/useLanguage';
import { useDisclosure } from '@mantine/hooks';
import { ColumnDefTemplate, HeaderContext } from '@tanstack/react-table';
import cn from 'classnames';
import { MdOutlineFilterAlt, MdRefresh } from 'react-icons/md';
import { KeyedMutator } from 'swr';
import ExportData from '../common/ExportData';
import { PortalNeutralButton } from '../common/PortalNeutralButton';

interface TableControlsProps {
    children?: React.ReactNode;
    excelData?: {
        data: any[];
        fileName: string;
        headerData: ColumnDefTemplate<HeaderContext<any, unknown>>[];
    };
    isManual?: boolean;
    isLoading: boolean;
    filterDisclosure: ReturnType<typeof useDisclosure>;
    mutate: KeyedMutator<any>;
    searchTitle?: string;
    hasSearch?: boolean;
    // onClick(): void;
}

const TableControls = (props: TableControlsProps) => {
    const { children, excelData, isLoading, filterDisclosure, mutate, searchTitle, hasSearch = true } = props;

    const lang = useLanguage();
    const [opened, handlers] = filterDisclosure;

    return (
        <div className="flex flex-wrap sm:justify-center items-center gap-3">
            {children}
            {children && <div className="h-5 w-0.5 bg-brand-neutral-600" />}
            {excelData && Object.keys(excelData).length && (
                <ExportData fileName={excelData?.fileName} excelData={excelData} />
            )}
            <PortalNeutralButton onClick={handlers.toggle}>
                <MdOutlineFilterAlt className="w-4 h-4" />
                {lang.blotters.filters}
            </PortalNeutralButton>
            {hasSearch && (
                <PortalNeutralButton
                    onClick={() => {
                        if (!isLoading) mutate();
                    }}
                    isLoading={isLoading}>
                    {!isLoading && (
                        <MdRefresh
                            className={cn('w-4 h-4', {
                                'animate-spin text-brand-neutral-400': isLoading
                            })}
                        />
                    )}
                    {searchTitle || lang.blotters.searchResults}
                </PortalNeutralButton>
            )}
        </div>
    );
};

export default TableControls;
